import {Box, Button, Typography, Hidden} from "@mui/material";
import {ReactComponent as PlusIcon} from "../assets/images/plus.svg";
import PageHeader from "../componenets/shared/PageHeader";
import {useState} from "react";
import {getCoupons} from "../services/system/CouponService";
import MiniCoupons from "../componenets/coupons/MiniCoupons";
import CouponDialog from "../componenets/coupons/CouponDialog";
import Loader from "../componenets/Loader";
import CouponSearchBar from "../componenets/coupons/CouponSearchBar";

const AdminCoupons = () => {

    const [newCoupon, setNewCoupon] = useState(false);

    const [loading] = useState(false);

    const [couponState, setCouponState] = useState({
        coupons: [],
        numberOfElements: 0,
        keyword: "",
        companyId: null,
        isActive: null,
        pageId: 0,
        hasMoreData: true,
        isLoading: true,
    });

    const updateKeyword = (keyword) => {
        setCouponState((prv) => {
            return {
                ...prv,
                totalNumberOfElements: 0,
                keyword: keyword,
                pageId: 0,
                coupons: [],
                hasMoreData: true,
                isLoading: true,
            };
        });
    };

    const reload = () => {
        setCouponState(() => {
            return {
                coupons: [],
                numberOfElements: 0,
                keyword: "",
                companyId: null,
                isActive: null,
                pageId: 0,
                hasMoreData: true,
                isLoading: true,
            }
        })
    }

    const updateCompanyId = (companyId) => {
        setCouponState((prv) => {
            return {
                ...prv,
                totalNumberOfElements: 0,
                companyId: companyId,
                pageId: 0,
                coupons: [],
                hasMoreData: true,
                isLoading: true,
            };
        });
    };

    const updateIsActive = (isActive) => {
        setCouponState((prv) => {
            return {
                ...prv,
                totalNumberOfElements: 0,
                isActive: isActive,
                pageId: 0,
                coupons: [],
                hasMoreData: true,
                isLoading: true,
            };
        });
    };

    const fetchNextPage = () => {
        getCoupons(
            couponState.pageId,
            20,
            couponState.keyword,
            couponState.companyId,
            couponState.isActive
        )
            .then((res) => {
                const content = res.data.content;

                setCouponState((prevState) => {
                    let newCoupons = [...prevState.coupons, ...content];

                    if (couponState.pageId === 0) {
                        newCoupons = content;
                    }

                    return {
                        ...prevState,
                        coupons: newCoupons,
                        numberOfElements: res.data.numberOfElements,
                        pageId: prevState.pageId + 1,
                        hasMoreData: content.length !== 0,
                        isLoading: false,
                    };
                });
            })
            .catch((e) => {
                setCouponState((prvState) => {
                    return { ...prvState, isLoading: false, hasMoreData: false };
                });
                console.log("Error: ", e);
            });
    };

    const handleClose = () => {
        setNewCoupon(false)
    }

    return (
        <>
            <Loader loading={loading} />
            <CouponDialog isOpen={newCoupon} close={handleClose} setReload={reload} />
            <PageHeader title={"קופונים"}>
                <Box sx={{marginTop: {xs: "0", md: "28px"}, display: "flex", justifyContent: {md: "flex-end", xs: "start"}, alignItems: "center"}}>
                    <Box sx={{display: {xs : "none", md: "inherit"}}}>
                        <Button variant="outlined"
                                onClick={() => setNewCoupon(true)}
                                sx={{backgroundColor: "#F2F4F7", height: "44px", width: "166px", "& .MuiButton-startIcon" : {
                                        marginRight: "-4px",
                                        marginTop: "2px",
                                        marginLeft: "8px",
                                    }}} startIcon={<PlusIcon/>}>
                            הוסף קופון
                        </Button>
                    </Box>
                </Box>
            </PageHeader>

            {/* Mobile Title and Add Button */}
            <Hidden mdUp>
                <Box sx={{
                    padding: "16px 16px 12px 16px",
                    direction: "rtl",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: "24px",
                            color: "#1E293B"
                        }}
                    >
                        קופונים
                    </Typography>
                    <Button
                        onClick={() => setNewCoupon(true)}
                        variant="contained"
                        size="small"
                        sx={{
                            backgroundColor: "primary.main",
                            color: "#FFFFFF",
                            fontSize: "13px",
                            fontWeight: 600,
                            padding: "6px 12px",
                            "&:hover": {
                                backgroundColor: "#059669"
                            },
                            "& .MuiButton-startIcon": {
                                marginRight: "-2px",
                                marginLeft: "4px",
                            }
                        }}
                        startIcon={<PlusIcon style={{ width: 16, height: 16 }} />}
                    >
                        הוסף קופון
                    </Button>
                </Box>
            </Hidden>

            <CouponSearchBar
                updateKeyword={updateKeyword}
                keyword={couponState.keyword}
                updateCompanyId={updateCompanyId}
                companyId={couponState.companyId}
                updateIsActive={updateIsActive}
                isActive={couponState.isActive}
            />
            <MiniCoupons reload={reload} couponState={couponState} fetchNextPage={fetchNextPage}/>
        </>
    );
};

export default AdminCoupons;